import { render, staticRenderFns } from "./ImageItem4Template.vue?vue&type=template&id=44c4b068"
import script from "./ImageItem4Template.vue?vue&type=script&lang=js"
export * from "./ImageItem4Template.vue?vue&type=script&lang=js"
import style0 from "./ImageItem4Template.vue?vue&type=style&index=0&id=44c4b068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports